export enum SituacaoBonusAfiliado {
    NAO_DISPONIVEL = 0,
    A_RECEBER = 1,
    EM_ANALISE = 2,
    RESGATADO = 3,
}
